import Search from './modules/search';

class Frontend {
    $ = jQuery;

    constructor() {
        $(document).ready(this.ready.bind(this));
        const search = new Search();
    }

    /**
     * Method called after document ready.
     */
    ready() {

    }
}

export default new Frontend();


